import { useSearchParams } from 'react-router-dom';

import { ConversationInfiniteList } from '@web/conversations/Conversation/ConversationInfiniteList/ConversationInfiniteList';
import { ConversationSearchList } from '@web/conversations/ConversationSearch/ConversationSearchList/ConversationSearchList';

export const ConversationMainSection = () => {
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get('query');

  return !searchQuery ? <ConversationInfiniteList /> : <ConversationSearchList />;
};
